import { ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BlogStudio } from "@/components/BlogStudio";

/** The operator's own blog desk — posts here land on their booking site. */
export default function BlogDesk() {
  const { company } = useAuth();
  const handle = company?.handle || company?.id || "";

  return (
    <div data-testid="blog-desk" className="space-y-6">
      <div>
        <h1 className="font-display text-2xl text-slate-100 sm:text-3xl">Blog</h1>
        <p className="mt-2 max-w-2xl text-sm text-slate-400">
          Posts you publish here show on your booking site, where customers and search engines find
          them. Give the AI a topic, read what it writes, then publish.
        </p>
        {handle && (
          <a data-testid="blog-public-link" href={`/book/${handle}/blog`} target="_blank"
            rel="noreferrer"
            className="mt-3 inline-flex items-center gap-1.5 text-sm text-gold hover:underline">
            /book/{handle}/blog <ExternalLink className="h-3.5 w-3.5" />
          </a>
        )}
      </div>
      <BlogStudio scope="operator" publicBase={handle} />
    </div>
  );
}
